import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const duplicateEventTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/event_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

interface DuplicateEventTemplateInput {
  uuid: string;
  name: string;
}

export function useDuplicateEventTemplate(onSuccessCallback: (newUuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateEventTemplateInput) => duplicateEventTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEventTemplates] });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the event template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
